import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Grid, Card, CardHeader, Avatar } from '@material-ui/core';
import { PieChart, Book } from '@material-ui/icons';

import GraphCard from './GraphCard';
import PieChartGraph from './PieChart';
import PlannedCost from './PlannedCost';

import '../../assets/stylesheets/DashboardView.css';

import i18n from '../../i18n';

class BookingInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandView: true,
    };
  }

  handleExpandClick = () => {
    this.setState((prevState) => ({ expandView: !prevState.expandView }));
  };

  generateGraphCard = (title, data, useCustomColors, showLegend = true) => {
    const { formattedSelectedDateRange } = this.props;
    return (
      <GraphCard
        title={title}
        subheader={formattedSelectedDateRange}
        graphAvatar={<PieChart />}
        contentWrapperStyle=""
        content={
          data.length ? (
            <PieChartGraph
              data={data}
              useCustomColors={useCustomColors}
              showLegend={showLegend}
            />
          ) : (
            <p className="centerText">{i18n.t('noData')}</p>
          )
        }
      />
    );
  };

  render() {
    const {
      bookingPerLocationData,
      bookingTypesData,
      bookingStatusData,
      fullTimeCost,
      freelancerCost,
      contractorCost,
      discrepancy,
    } = this.props;

    return (
      <Grid container>
        <Grid item xs={6}>
          <Card className="cardContainer">
            <CardHeader
              avatar={
                <Avatar className="cardAvatar" aria-label="progress-info-icon">
                  <Book color="secondary" />
                </Avatar>
              }
              title={i18n.t('dashboard:bookingInfo')}
              subheader={i18n.t('dashboard:bookingInfoSubtitle')}
            />
          </Card>
        </Grid>
        <Grid item xs={6} />

        <Grid item xs={6}>
          <PlannedCost
            fullTimeCost={fullTimeCost}
            freelancerCost={freelancerCost}
            contractorCost={contractorCost}
            discrepancy={discrepancy}
          />
        </Grid>
        <Grid item xs={6} />

        <Grid item xs={4}>
          {this.generateGraphCard(
            i18n.t('dashboard:BookingPerLocation'),
            bookingPerLocationData,
            false,
            false
          )}
        </Grid>
        <Grid item xs={4}>
          {this.generateGraphCard(
            i18n.t('dashboard:BookedEmployeeTypes'),
            bookingTypesData,
            true,
          )}
        </Grid>
        <Grid item xs={4}>
          {this.generateGraphCard(
            i18n.t('dashboard:BookingStatus'),
            bookingStatusData,
            true,
          )}
        </Grid>
      </Grid>
    );
  }
}

BookingInfo.propTypes = {
  formattedSelectedDateRange: PropTypes.string.isRequired,
  bookingPerLocationData: PropTypes.arrayOf(PropTypes.object).isRequired,
  bookingTypesData: PropTypes.arrayOf(PropTypes.object).isRequired,
  bookingStatusData: PropTypes.arrayOf(PropTypes.object).isRequired,
  fullTimeCost: PropTypes.number.isRequired,
  freelancerCost: PropTypes.number.isRequired,
  contractorCost: PropTypes.number.isRequired,
  discrepancy: PropTypes.arrayOf(PropTypes.shape({
    studioEmployeeId: PropTypes.number,
    positionId: PropTypes.number,
    availabilityType: PropTypes.string,
    date: PropTypes.string,
  })).isRequired,
};

export default BookingInfo;
